import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Add a New Book", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Book title:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "author" }, "Book author:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", null, "Add Book", -1)

import { ref } from 'vue'
import { db } from "../firebase/config"
import { addDoc, collection } from "firebase/firestore"
import { getUser } from '@/composables/getUser'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = getUser()
const title = ref('')
const author = ref('')

const handleSubmit = async () => {
  const colRef = collection(db, 'books')

  await addDoc(colRef, {
    title: title.value,
    author: author.value,
    isFav: false,
    userUid: user.value?.uid
  })

  title.value = ''
  author.value = ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(handleSubmit, ["prevent"])
  }, [
    _hoisted_2,
    _hoisted_3,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      name: "title",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
      required: ""
    }, null, 512), [
      [_vModelText, title.value]
    ]),
    _hoisted_4,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      name: "author",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((author).value = $event)),
      required: ""
    }, null, 512), [
      [_vModelText, author.value]
    ]),
    _hoisted_5
  ], 40, _hoisted_1))
}
}

})